import { render, staticRenderFns } from "./HeaderRegister1.vue?vue&type=template&id=7a507ea1"
import script from "./HeaderRegister1.vue?vue&type=script&lang=ts"
export * from "./HeaderRegister1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports